import { getAppTranslations, Translations, TranslationsPlatform } from 'services/translations'
import { USE_TRANSLATIONS } from 'config'
import i18n from 'i18next'
import { getLanguage } from 'services/translations/lib/hook/useGetLanguage'

export const TranslationsUtils = {
  isForApp: (translation: Translations) => {
    return translation.platform === TranslationsPlatform.APP
  },
  isForWeb: (translation: Translations) => {
    return translation.platform === TranslationsPlatform.WEB
  },
}

export const loadDynamicTranslations = async () => {
  if (USE_TRANSLATIONS) {
    try {
      const currentLang = getLanguage()

      const translations = await getAppTranslations(currentLang)
      i18n.addResourceBundle(currentLang, 'translation', translations, true, true)

      await i18n.changeLanguage(currentLang)

      console.debug(`Dynamic translations loaded successfully for language: ${currentLang}`)
    } catch (e) {
      console.error('Error loading dynamic translations:', e)
    }
  }
}

export const determineInitialLanguage = () => {
  const browserLang = navigator.language || navigator.languages[0]

  const langPrefix = browserLang.split('-')[0].toLowerCase()

  if (['it', 'en', 'es', 'de', 'zh'].includes(langPrefix)) {
    return langPrefix
  }

  return 'en'
}
